import { Fragment, useMemo } from "react";
import PropTypes from "prop-types";
import { parseTextLinks } from "@utils/parse-text-links";
import FaviconLink from "./favicon-link";

/**
 * 텍스트 안의 주소만 링크로 바꿔 보여 준다. (DAM-858)
 *
 * 설명이나 커스텀 메타데이터(string) 값처럼 자유 입력 텍스트를 그대로 출력하던 자리에
 * `{value}` 대신 끼워 쓴다. 주소가 하나도 없으면 받은 값을 그대로 돌려주므로 기존 표시와
 * 달라지지 않는다.
 *
 * @param {Object} props
 * @param {*} props.text - 표시할 값. 문자열이 아니면 그대로 출력한다.
 * @param {number} [props.maxLength] - 링크 라벨 축약 기준 길이.
 */
const LinkText = ({ text, maxLength }) => {
    const segments = useMemo(() => parseTextLinks(text), [text]);

    if (!segments.some((segment) => segment.type === "link")) return text ?? null;

    return segments.map((segment, index) =>
        segment.type === "link" ? (
            <FaviconLink key={index} href={segment.href} maxLength={maxLength} />
        ) : (
            <Fragment key={index}>{segment.value}</Fragment>
        ),
    );
};

LinkText.propTypes = {
    text: PropTypes.node,
    maxLength: PropTypes.number,
};

export default LinkText;
